import { useQuery } from "@tanstack/react-query";
import { ApiError, useApi } from "./api";

export interface MeUser {
  id: string;
  email: string;
  display_name: string | null;
  avatar_url: string | null;
  role: string;
  primary_community_id: string | null;
  city: string | null;
  region: string | null;
  country: string | null;
  identity_json: string | null;
  pillars_json: string | null;
  onboarded_at: number | null;
}

/**
 * Fetches the D1-mirrored user row. Returns `user: null` if the user hasn't
 * been onboarded yet (server returns 404 in that case — onboarding fills it in).
 */
export function useUserMe() {
  const api = useApi();
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<{ user: MeUser | null }> => {
      try {
        return await api.get<{ user: MeUser }>("/auth/me");
      } catch (e) {
        if (e instanceof ApiError && e.status === 404) return { user: null };
        throw e;
      }
    },
    staleTime: 60_000,
  });
}
